export const SmallDrawerWidth = 400;
export const MediumDrawerWidth = 520;
export const MediumLargeDrawerWidth = 640;
export const LargeDrawerWidth = 930;
export const ExtraLargeDrawerWidth = 1590;
export const DrawerWidth570 = 570;
